module.exports = __webpack_public_path__ + "assets/88d8958ad42767c13becba7526d4e6d9.mp3";